<div class="mainselect col">
  <div class="row menuetext w100 align-center">
    <span class="selecttext" [routerLink]="continueLink">{{ selectname }}</span>
    <span class="slash"></span>
    <!-- <rr-icon
      class="chevron"
      name="chevron-down"
      color="brand"
      (click)="toggleMenue()"
    ></rr-icon> -->
    <rr-icon
      class="chevron"
      name="trash"
      color="brand"
      (click)="deleteTrack()"
    ></rr-icon>
  </div>
  <div class="dropdown col" *ngIf="showMenue">
    <div
      class="item w100 col"
      *ngFor="let item of itemList"
      [ngClass]="item.status"
      [routerLink]="item.status !== 'continue' ? item.routerLink : null"
    >
      {{ item.itemName }}
    </div>
    <rr-divider></rr-divider>
    <div class="item w100 col active" (click)="deleteTrack()">Delete</div>
  </div>
</div>
<div class="backdrop" *ngIf="showMenue" (click)="showMenue = false"></div>
